const essencialModul = {

  agGrid: {
    pagination: true,
    pagina: 15,
    id: 'myGrid',
    class: 'ag-theme-alpine',
    style: {
        width: '100%',
        height: '700px'
    }
},
agGridModal: {
    paginacion: 10,
    id: 'myGrid',
    class: 'ag-theme-material mt-3',
    style: {
        width: '100%',
        height: '450px'
    }
},
titulos: {
    titulo: 'Registro de Jerarquia Essencial',
    modulo: 'Jerarquia Essencial',
    tituloCardList  : 'Listado de Jerarquia',
    tituloAgregar   : 'Agregar Nueva Jerarquia',
    tituloActualizar: 'Agregar Jerarquia Nivel 2',
    tituloEliminar  : 'Eliminar Jerarquia',

    relacionGrupoSubcanal: {
        titulo: 'Registro de relacion Grupo-SubCanal',
        modulo: 'Relacion Grupo-SubCanal',
        tituloCardList  : 'Listado de Grupo-SubCanal',
    }
    
},

url: {
    essentialcrud   : 'jerarquia-essential',
    essentialNivel  : 'jerarquia-essential/nivel/',
    essentialfindId : 'jerarquia-essential/findId',
    csvEssential    : "jerarquia-essential/upload/csv",

    grupoSubCanalcrud: "/relacion_grupovendedor_subcanal",

    }

}

export {essencialModul}
